import { Component, OnInit } from '@angular/core';
import { CustomerService } from 'src/app/services/customer.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-like-analytics',
  templateUrl: './like-analytics.component.html',
  styleUrls: ['./like-analytics.component.css'],
})
export class LikeAnalyticsComponent implements OnInit {
  loading: boolean = true;
  analyticsData: any;
  chartOptionsMale: any = {};
  chartOptionsFemale: any = {};
  chartOptionsAll: any = {};
  isActiveUsers: boolean = false;

  constructor(
    private customerService: CustomerService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.fetchData();
  }

  toggleUserType(event: any) {
    this.isActiveUsers = event.target.checked;
    this.fetchData();
  }

  fetchData() {
    this.loading = true;
    const token = localStorage.getItem('token');

    this.customerService
      .getLikeBehaviorAnalytics(token, this.isActiveUsers)
      .subscribe({
        next: (res: any) => {
          if (res.status == 200 || res.success) {
            this.analyticsData = res.data;
            this.processData();
          } else {
            this.toastr.error('Failed to load like analytics data');
          }
          this.loading = false;
        },
        error: (err: any) => {
          console.error('Like Analytics Fetch Error', err);
          this.toastr.error('Error loading data');
          this.loading = false;
        },
      });
  }

  processData() {
    if (!this.analyticsData) return;

    this.createChart(
      this.analyticsData.male,
      'Male Users Like Behavior',
      'chartOptionsMale'
    );
    this.createChart(
      this.analyticsData.female,
      'Female Users Like Behavior',
      'chartOptionsFemale'
    );
    this.createChart(
      this.analyticsData.all,
      'All Users Like Behavior',
      'chartOptionsAll'
    );
  }

  createChart(
    data: any,
    title: string,
    optionsVar: 'chartOptionsMale' | 'chartOptionsFemale' | 'chartOptionsAll'
  ) {
    if (!data) return;

    const receivedData = data.received || {};
    const sentData = data.sent_before_paid || {};

    const categories = [
      '0',
      '1_3',
      '4_10',
      '11_20',
      '21_30',
      '31_50',
      '50_plus',
    ];
    const labels: { [key: string]: string } = {
      '0': '0',
      '1_3': '1-3',
      '4_10': '4-10',
      '11_20': '11-20',
      '21_30': '21-30',
      '31_50': '31-50',
      '50_plus': '50+',
    };

    const receivedPoints = categories.map((cat) => ({
      label: labels[cat],
      y: receivedData[cat] || 0,
    }));

    const sentPoints = categories.map((cat) => ({
      label: labels[cat],
      y: sentData[cat] || 0,
    }));

    this[optionsVar] = {
      animationEnabled: true,
      exportEnabled: true,
      theme: 'light2',
      title: {
        text: title,
      },
      axisY: {
        title: 'Number of Users',
        includeZero: true,
      },
      axisX: {
        title: 'Number of likes sent/received before buying a subscription',
        labelAngle: -45,
      },
      toolTip: {
        shared: true,
        contentFormatter: function (e: any) {
          let content =
            '<strong>' + e.entries[0].dataPoint.label + '</strong><br/>';
          for (let i = 0; i < e.entries.length; i++) {
            content +=
              e.entries[i].dataSeries.name +
              ': ' +
              '<strong>' +
              e.entries[i].dataPoint.y +
              '</strong> Users<br/>';
          }
          return content;
        },
      },
      legend: {
        cursor: 'pointer',
        itemclick: function (e: any) {
          if (
            typeof e.dataSeries.visible === 'undefined' ||
            e.dataSeries.visible
          ) {
            e.dataSeries.visible = false;
          } else {
            e.dataSeries.visible = true;
          }
          e.chart.render();
        },
      },
      data: [
        {
          type: 'column',
          name: 'Received Likes (Total)',
          showInLegend: true,
          color: '#007BFF', // Blue
          dataPoints: receivedPoints,
        },
        {
          type: 'column',
          name: 'Sent Likes (Before Paid)',
          showInLegend: true,
          color: '#FFD700', // Yellow
          dataPoints: sentPoints,
        },
      ],
    };
  }
}
